export class UpdateScreeningTime {
  static readonly type = '[Reservation] Update Screening Time';
  constructor(public screeningTimeFrom: string | null) {}
}
